/**
 * Resolve o crew_id a partir de env vars com fallback em dev.
 */
export const resolveCrewId = (
  envValue: string | undefined,
  fallback: number
): number | null => {
  const parsed = Number(envValue);
  if (Number.isFinite(parsed) && parsed > 0) {
    return parsed;
  }

  if (process.env.NODE_ENV === 'development') {
    return fallback;
  }

  return null;
};

/**
 * Resolve o crew_id de geração por ambiente.
 */
export const resolveGenerateCrewId = (params: {
  devEnvValue: string | undefined;
  prodEnvValue: string | undefined;
  devFallback: number;
}): number | null => {
  const { devEnvValue, prodEnvValue, devFallback } = params;
  const isDevelopment = process.env.NODE_ENV === 'development';

  if (isDevelopment) {
    return resolveCrewId(devEnvValue, devFallback);
  }

  const parsed = Number(prodEnvValue);
  if (Number.isFinite(parsed) && parsed > 0) {
    return parsed;
  }

  return null;
};
